import { render, staticRenderFns } from "./CampaignLandingDestinations.vue?vue&type=template&id=1bfe340c&scoped=true&"
import script from "./CampaignLandingDestinations.vue?vue&type=script&lang=js&"
export * from "./CampaignLandingDestinations.vue?vue&type=script&lang=js&"
import style0 from "./CampaignLandingDestinations.vue?vue&type=style&index=0&id=1bfe340c&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfe340c",
  null
  
)

export default component.exports